<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
      require: false,
    },
    classHeader: {
      type: String,
      default: '',
      require: false,
    },
    nonHeader: {
      type: Boolean,
      require: false,
    },
    hasFooter: {
      type: Boolean,
      require: false,
    },
    formCollapsed: {
      type: Boolean,
      require: false,
    },
    triggerMask: {
      type: Boolean,
      require: false,
    },
    errors: {
      type: Object,
      require: false,
      default: () => {},
    },
  },
  data() {
    return {
      openConfirm: false,
    }
  },
  watch: {
    errors() {
      if (this.errors) {
        this.$refs.observer.setErrors(this.errors)
      }
    },
  },
  methods: {
    showConfirm() {
      this.openConfirm = true
    },
    closeModalConfirm() {
      this.openConfirm = false
    },
    submit() {
      this.$emit('submit')
      this.closeModalConfirm()
    },
    edit() {
      this.$emit('edit')
    },
    getClassHeader() {
      return (!this.nonHeader ? 'card-detail-header ' : ' ') + this.classHeader
    },
  },
}
</script>

<template>
  <validation-observer ref="observer" v-slot="{ handleSubmit }">
    <CForm
      id="base-card-detail"
      class="position-relative"
      @submit.stop.prevent="handleSubmit(showConfirm)"
    >
      <CCard class="shadow-sm">
        <CCardHeader
          class="d-flex justify-content-between align-items-center p3"
          :class="getClassHeader()"
        >
          <h5 class="font-weight-bold mb-0">{{
            title || $route.meta.label
          }}</h5>
          <div>
            <slot name="header-action" :edit="edit">
              <CButton variant="ghost" @click="$emit('edit')">
                <CIcon name="cil-pencil" />
              </CButton>
            </slot>
          </div>
        </CCardHeader>
        <CCollapse :show="formCollapsed">
          <CCardBody>
            <slot></slot>
          </CCardBody>
        </CCollapse>
        <CCardFooter v-if="hasFooter" align="right">
          <slot name="action">
            <CButton color="primary" type="submit">
              {{ $t('confirm.edit.btn') }}
            </CButton>
            <CButton
              type="button"
              color="dark"
              class="ml-2"
              variant="outline"
              @click="$emit('cancel')"
            >
              {{ $t('common.cancel') }}
            </CButton>
          </slot>
        </CCardFooter>
      </CCard>
      <div v-if="triggerMask" class="mask" />
    </CForm>
    <BaseModalConfirm
      :show.sync="openConfirm"
      type="edit"
      @closeModal="closeModalConfirm"
      @submit="submit"
    />
  </validation-observer>
</template>

<style lang="scss" scoped>
#base-card-detail {
  .card-detail-header {
    height: 60px;
    color: $custom-filter-box-card-title-color;
    background-color: $feelline-bg-primary;
  }
  ::v-deep .mask {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    height: 100%;
    background-color: gray;
    opacity: 0.5;
  }
}
</style>
